var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ spinner: !_vm.small, 'spinner-small': !!_vm.small, 'spinner-dark': !!_vm.dark }},[(!_vm.small)?_c('span'):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }